var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"YYYY-MM-DD","placeholder":_vm.placeholder},on:{"panelChange":_vm.onPanelChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }